import {
  ButtonBase,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import React from 'react'

import { LocalizedLink } from '../../routes/localizedRoutes'
import { ProviderBrief } from '../../types/provider'
import useStyles from './styles/TemplatesTable.styles'

interface ProviderRowProps {
  data: ProviderBrief
}

const ProviderRow: React.FC<ProviderRowProps> = ({ data }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.roleRowRoot}>
      <ButtonBase
        className={[
          classes.tableRow,
          isSmallScreen ? classes.tableRowSkeletonForMobile : ''
        ].join(' ')}
        component={LocalizedLink}
        to={`/provider/${data.id}/${data.providerCode}/details`}>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.name}</Typography>
        </div>
        <div className={classes.nameCell}>
          <Typography variant="h4">{data.displayProviderCode}</Typography>
        </div>
      </ButtonBase>
    </div>
  )
}

export default ProviderRow
